import styled from "styled-components";
export const OrganizationContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 0;
`;

export const MetadataContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  margin-top: 20px;
  background: #f7f9fa;
  padding: 25px;
  border-radius: 10px;
`;

export const MetadataItem = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const IconContainer = styled.div`
  margin-right: 15px;
  width: 40px;
  height: 40px;
  background: #e9f5ec;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #008394;
    font-size: 20px;
  }
`;

export const MetadataContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MetadataLabel = styled.span`
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
`;

export const MetadataValue = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const DeadlineIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${(props) => (props.isApproaching ? "#fff3cd" : "#e9f5ec")};
  color: ${(props) => (props.isApproaching ? "#856404" : "#008394")};
  padding: 5px 10px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 13px;
  font-weight: 500;

  svg {
    margin-right: 5px;
  }
`;

export const MotivationCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 25px 0;
  background: #f7f9fa;
  padding: 25px;
  border-radius: 10px;
`;

export const MotivationItem = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 10px;
  transition: all 0.3s ease;
  border-radius: 8px;
  
  &:hover {
    background: #e9f5ec;
  }
`;

export const LevelCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 25px 0;
`;

export const LevelItem = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 20px;
  border-radius: 10px;
  background: #f7f9fa;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

export const LevelTitle = styled.h4`
  font-size: 18px;
  font-weight: 700;
  color: #008394;
  margin: 0 0 10px 0;
`;

export const LevelDescription = styled.p`
  font-size: 16px;
  color: #333;
  line-height: 1.5;
`;

export const EligibilityList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const EligibilityItem = styled.li`
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  font-size: 16px;
  color: #333;
  
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 8px;
    width: 8px;
    height: 8px;
    background-color: #008394;
    border-radius: 50%;
  }
`;

export const CardHeader = styled.h4`
  font-size: 18px;
  font-weight: 600;
  color: #008394;
  margin: 0 0 10px 0;
`;

export const PrizesList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 5px 0 0 0;
`;

export const PrizeItem = styled.li`
  position: relative;
  padding-left: 25px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
  
  &:before {
    content: "✓";
    position: absolute;
    left: 0;
    top: 0;
    font-size: 14px;
    color: #008394;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ExternalLink = styled.a`
  color: #2c7a51;
  font-weight: 600;
  text-decoration: none;
  border-bottom: 2px solid #2c7a51;
  transition: all 0.3s ease;
  
  &:hover {
    color: #1a5735;
    border-bottom: 2px solid #1a5735;
  }
`;


// Helper function to check if deadline is approaching (within 7 days)
export const isDeadlineApproaching = (deadlineDate) => {
  const deadline = new Date(deadlineDate);
  const today = new Date();
  const differenceInDays = Math.ceil(
    (deadline - today) / (1000 * 60 * 60 * 24)
  );

  return differenceInDays >= 0 && differenceInDays <= 7;
};

// Helper function to format date
export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

// Calculate days remaining until deadline
export const getDaysRemaining = (deadlineDate) => {
  const deadline = new Date(deadlineDate);
  const today = new Date();
  const differenceInDays = Math.ceil(
    (deadline - today) / (1000 * 60 * 60 * 24)
  );

  return differenceInDays;
};
